export const alwaysArray = <T = string>(value?: T | T[]): T[] =>
  value ? (Array.isArray(value) ? value : [value]) : [];
